"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GravityFluxAbilityHandler = exports.GravityFluxActorAbilityFactory = exports.GravityFluxAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Stun_1 = require("../../core/effects/core/Stun");
const Registries_1 = require("../../core/state/Registries");
class GravityFluxAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.GravityFlux;
        this.__typeName = "GravityFlux";
    }
}
exports.GravityFluxAbilityArgs = GravityFluxAbilityArgs;
let GravityFluxActorAbilityFactory = class GravityFluxActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("GravityFlux", "OneEnemies", 3);
    }
};
GravityFluxActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("GravityFlux")
], GravityFluxActorAbilityFactory);
exports.GravityFluxActorAbilityFactory = GravityFluxActorAbilityFactory;
let GravityFluxAbilityHandler = class GravityFluxAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Chaos", 150)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(2),
                    effect: new Stun_1.StunEffectArgs()
                });
            }
        });
    }
};
GravityFluxAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.GravityFlux)
], GravityFluxAbilityHandler);
exports.GravityFluxAbilityHandler = GravityFluxAbilityHandler;
